import React from 'react';
import { ratingMeta } from './groupMeta';

export const RatingBadge = ({ rating, size = 'sm', testId }) => {
  const m = ratingMeta(rating);
  const big = size === 'lg';
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full border font-semibold whitespace-nowrap ${big ? 'px-3.5 py-1.5 text-xs' : 'px-2.5 py-1 text-[10px] tracking-[0.06em]'}`}
      style={{ background: `${m.hex}1a`, borderColor: `${m.hex}55`, color: m.hex, boxShadow: big ? `0 0 24px -8px ${m.hex}` : undefined }}>
      <m.Icon className={big ? 'w-4 h-4' : 'w-3 h-3'} /> {big ? m.label : m.short}
    </span>
  );
};
